import { Fullscreen } from "./fullscreen";
import fullscreenLayout from "./fullscreenLayout";

export default {
  view: Fullscreen,
  layoutDetails: fullscreenLayout
};